module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-700.woff?2ea3c06a57b0de51ea36cd45da121eaa";